export default "/images/94eb14e3e53ed9b20662fb39ab864842.png";